module.exports = __webpack_public_path__ + "img/f-3.ba6cd86d.jpg";